// frontend/src/api/gifApi.js
import { supabase } from '../lib/supabase';

export async function saveGifSticker(imageId, gifMetadata, sentiment, instagramAccountId) {
  const { data: { session } } = await supabase.auth.getSession();

  const response = await fetch(`${import.meta.env.VITE_API_URL}/images/${imageId}/gif-sticker`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`,
      'X-User-ID': session.user.id
    },
    body: JSON.stringify({
      ...gifMetadata,
      sentiment,
      instagram_account_id: instagramAccountId
    })
  });

  if (!response.ok) {
    throw new Error('Failed to save GIF sticker');
  }

  return response.json();
}

export async function removeGifSticker(imageId, sentiment, instagramAccountId) {
  const { data: { session } } = await supabase.auth.getSession();

  const response = await fetch(`${import.meta.env.VITE_API_URL}/images/${imageId}/gif-sticker?sentiment=${encodeURIComponent(sentiment)}&instagram_account_id=${encodeURIComponent(instagramAccountId)}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${session.access_token}`,
      'X-User-ID': session.user.id
    }
  });

  if (!response.ok) {
    throw new Error('Failed to remove GIF sticker');
  }
}
